import "react-datepicker/dist/react-datepicker.css";
import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
import "react-app-polyfill/ie11"; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import {authProvider} from "./authProvider";
import {AzureAD} from "react-aad-msal";
import './AxiosAuthProvider'
import {environment} from "./config";


let AppInternal = () => {
  return environment.disableAuth ? <App/> : <AzureAD provider={authProvider} forceLogin={true}>
    <App/>
  </AzureAD>
}

ReactDOM.render(<AppInternal/>, document.getElementById("root"))
